module.exports = __webpack_public_path__ + "static/img/ent-detail-40.4491bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-40.jpg
// module id = PZsa
// module chunks = 52